<template>
  <SeoBlogArticle :content="$t('seoArticleComoRastrearCliques')"/>
</template>
<script>
import SeoBlogArticle from "../fragments/SeoBlogArticle.vue";
export default {
  name: 'ArticleComoRastrearCliques',
  components: { SeoBlogArticle },
}
</script>
